var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckSchedule({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24.5,
    r: 24,
    fill: "#4F8F80"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2937 30.3592L33.6912 15.9617C33.939 15.7136 34.229 15.587 34.5612 15.5817C34.8934 15.5764 35.1888 15.7031 35.4475 15.9617C35.7061 16.2203 35.8354 16.5173 35.8354 16.8525C35.8354 17.1881 35.7061 17.4852 35.4475 17.7438L20.3483 32.8688C20.0469 33.1699 19.6954 33.3205 19.2937 33.3205C18.892 33.3205 18.5405 33.1699 18.2391 32.8688L11.2808 25.9105C11.033 25.6624 10.9108 25.368 10.9141 25.0271C10.9172 24.6866 11.048 24.387 11.3066 24.1284C11.5652 23.8698 11.8622 23.7404 12.1975 23.7404C12.533 23.7404 12.8301 23.8698 13.0887 24.1284L19.2937 30.3592Z",
    fill: "#F5F5F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckSchedule);
export default __webpack_public_path__ + "static/media/checkSchedule.2559bad1ed0a81218c27e34a0af676f6.svg";
export { ForwardRef as ReactComponent };